import { z } from 'zod';

const envConfigSchema = z.object({
  VITE_ENABLE_MOCKS: z.stringbool().optional(),
  VITE_API_DEBUG_DELAY: z.coerce.number().optional(),
  VITE_API_BASE_URL: z.string().optional(),
});

const parsedEnv = envConfigSchema.safeParse(import.meta.env);

if (!parsedEnv.success) {
  const errorMessages = parsedEnv.error.issues
    .map((issue) => `  • ${issue.path}: ${issue.message}`)
    .join('\n');

  throw new Error(
    `❌ Environment Configuration Error\n\nMissing or invalid variables:\n${errorMessages}\n\nCheck your .env file.`
  );
}

export const ENV_CONFIG = {
  enableMocks: parsedEnv.data.VITE_ENABLE_MOCKS,
  apiDebugDelay: parsedEnv.data.VITE_API_DEBUG_DELAY ?? 0,
  apiBaseUrl: parsedEnv.data.VITE_API_BASE_URL ?? '',
};
